import { render, staticRenderFns } from "./lensphoto-findings.vue?vue&type=template&id=346f9870&"
import script from "./lensphoto-findings.vue?vue&type=script&lang=js&"
export * from "./lensphoto-findings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports